module.exports = __webpack_public_path__ + "static/media/aff.8a6f5d2e.png";